import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { OrganizationResponse, OrganizationSearchParams } from './types';

/** The list envelope plus the COUNT the server runs over the same WHERE. */
export type OrganizationsSearchResponse = PaginatedListResponse<OrganizationResponse> & { total?: number | null };

export async function searchOrganizations(params: OrganizationSearchParams = {}) {
  const url = '/web/studio/organizations';

  const queryParams: Record<string, string | number | boolean> = {};

  if (params.search) queryParams.search = params.search;
  if (params.limit !== undefined) queryParams.limit = params.limit;
  if (params.offset !== undefined) queryParams.offset = params.offset;
  if (params.sortColumn) queryParams.sort_column = params.sortColumn;
  if (params.sortDirection) queryParams.sort_direction = params.sortDirection;
  if (params.includeDestroyed !== undefined) queryParams.include_destroyed = params.includeDestroyed;
  if (params.status) queryParams.status = params.status;
  if (params.givingEnabled !== undefined) queryParams.giving_enabled = params.givingEnabled;
  if (params.type) queryParams.type = params.type;

  const response = await api.executeGetRequest<OrganizationsSearchResponse>(url, queryParams);

  return response;
}
